import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="font-mono text-xs uppercase tracking-widest text-neutral-500">
                    Kimlik doğrulanıyor…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/giris" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/panel" replace />;
    return children;
}
